module.exports = __webpack_public_path__ + "static/media/traffic-light.fa8fc1c0.png";